import { api } from "@/_store/api-client";
import {
  IGenerateReportRequest,
  IGenerateReportResponse,
  IUpdateReportRequest,
  IUpdateReportResponse
} from "./contracts";

export const reportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateReport: builder.mutation<IUpdateReportResponse, IUpdateReportRequest>({
      query: (requestBody) => ({
        url: "/api/v1/update-report/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["UpdateReport"],
    }),
    generateReport: builder.mutation<IGenerateReportResponse, IGenerateReportRequest>({
      query: (requestBody) => ({
        url: "/api/v1/generate-file/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["GenerateReport"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateReportMutation,
  useGenerateReportMutation,
} = reportApi;
